import { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { FreightPackages } from "./FreightPackages";

const field = "w-full rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-white/40";

// Raio de entrega grátis a partir de Areado - MG e o aviso para quem está fora dele.
export const DeliverySettings = () => {
  const [radius, setRadius] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    api.get("/delivery/settings").then((r) => {
      setRadius(String(r?.data?.radius_km ?? ""));
      setMessage(r?.data?.outside_message ?? "");
    }).catch(() => null);
  }, []);
  const save = async () => {
    try {
      const { data } = await api.put("/admin/delivery", { radius_km: Number(radius.replace(",", ".")) || 0, outside_message: message });
      setMessage(data?.outside_message ?? message);
      toast.success(`Entrega grátis em até ${data?.radius_km} km salva`);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <section data-testid="admin-delivery" className="mt-8 rounded-[24px] border border-white/10 bg-[#111113] p-5 sm:p-6">
      <div className="flex items-center gap-2.5"><Truck className="h-5 w-5 text-white" /><h2 className="font-display text-xl font-bold">Entrega</h2></div>
      <p className="mt-2 text-sm text-zinc-400">Na página do aparelho o cliente digita a cidade ou o CEP e o site calcula a distância pela estrada até Areado - MG. Fora do raio, ele calcula o frete dos Correios (PAC e SEDEX, com e sem seguro) pelo Melhor Envio.</p>
      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-[200px_1fr]">
        <label className="text-sm text-zinc-300">Raio sem taxa (km)
          <input data-testid="delivery-radius-input" inputMode="numeric" value={radius} onChange={(e) => setRadius(e.target.value.replace(/[^\d,.]/g, "").slice(0, 5))} className={`${field} mt-1.5`} />
        </label>
        <label className="text-sm text-zinc-300">Aviso para quem está fora do raio
          <input data-testid="delivery-message-input" value={message} maxLength={200} onChange={(e) => setMessage(e.target.value)} className={`${field} mt-1.5`} />
        </label>
      </div>
      <button type="button" data-testid="delivery-save" onClick={save} className="mt-4 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-black transition-transform hover:scale-[1.02]">Salvar entrega</button>
      <FreightPackages />
    </section>
  );
};
